export function isValueType(value: unknown) {
  return typeof value !== 'object' || value === null;
}
